// mqtt-handlers.js - Create MQTT listeners outside component to avoid re-renders
import { getGroupIDFromTopic } from "../validation/utils";
// Redux Store actions
import { updateHeart } from '../redux/heartSlice';
import { updateGroup } from '../redux/groupSlice';


export const createStatusListener = (heart, dispatch, id) => (topic, message) => {
    try {
        console.log('Received message in heartContainer status listener:', topic, message.toString());
        const msg = message.toString();

        if (msg.startsWith("Online") || msg.startsWith("Offline")) {
            const [rawStatus, rawMac] = msg.split(",");
            const status = rawStatus.trim();
            const mac = rawMac.trim();

            // only update if the message's mac matches the local heart id
            console.log("Compare", heart.id, mac)
            if (mac === heart.id) {
                console.log("Updating heart status for", mac)
                // Update the heart's status in the local heart state  
                const updatedHeart = {...heart, status: status}
                dispatch(updateHeart({id: id, updatedHeart: updatedHeart}))
            }

        }
    } catch (err) {
        console.error("Error within status listener:", err)
    }
}

/** 
 * Listener to handle messages to color topic
 * Expected payload: <ColorNumber,Sender Heart MAC,Sender Heart NAME>
*/
export const createColorListener = (groups, dispatch) => (topic, message) => {
  const group_id = getGroupIDFromTopic(topic);
    const group = groups.find((group) => group.id === group_id);
    if(group) {
      const receivedColorNumber = parseInt(message.toString().split(",")[0])
      const receivedSenderMAC = message.toString().split(",")[1]
      const receivedSenderName = message.toString().split(",")[2]

      // ignore negative colorMessages (used when syncing hearts that come back online with the group's color)
      
      console.log("Received Color Number", receivedColorNumber, receivedColorNumber < 0)
      
      // Ignore negative color number messages
      if (receivedColorNumber < 0) {
        console.log("Negative colorMessage number, ignoring")
        return
      }

      console.log("Group found: ", group.id, "updating color to: ", receivedColorNumber);
      const updatedGroup = {...group, color: receivedColorNumber};

      // Made this a local change (don't write to server). Only write to server when publishing message.
      dispatch(updateGroup({id: group.id, updatedGroup: updatedGroup}));
    } else {
      console.log("No group found with ID: ", group_id);
    }
}